import {Book, PAGE_INTERVAL_KTM, PAGE_TRANSITION_KTM, PageTransition} from "../types";
import React, {ReactElement} from "react";
import {PageView} from "./PageView";
import {Swiper, SwiperSlide} from "swiper/react";
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-cube';
import {
  Autoplay,
  EffectCards,
  EffectCoverflow,
  EffectCreative,
  EffectCube,
  EffectFade,
  EffectFlip, Keyboard, Navigation,
  Pagination
} from "swiper/modules";
import {CARD_SHADOW_LARGE} from "@/shared/dimens";
import {IconButton, Typography} from "@mui/material";
import {StyledBoxRow} from "@/shared/StyledComponents";
import {PauseCircleOutlineOutlined, PlayCircleOutlineOutlined} from "@mui/icons-material";

enum AutoplayState {
  PLAY,
  PAUSE,
}

export function Preview(props: { book: Book }): ReactElement {
  const [autoplayState, setAutoplayState] = React.useState<AutoplayState>(AutoplayState.PLAY);
  const prefs = props.book.preferences;
  const transition = prefs.pageTransition;
  const interval = prefs.pageInterval;
  return <div
    style={{
      width: "100dvw",
      height: "100dvh",
      display: "flex",
      flexDirection: "column",
      background: "#222",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
    }}>
    <Swiper
      loop={true}
      effect={PAGE_TRANSITION_KTM.findMetadata(transition)?.swiperEffect}
      style={{
        width: "calc(92dvh * 3/2)", maxWidth: "100dvw",
        boxShadow: CARD_SHADOW_LARGE,
        aspectRatio: 3 / 2,
      }}
      keyboard={{
        enabled: true,
      }}
      navigation={true}
      autoplay={{
        delay: PAGE_INTERVAL_KTM.findMetadata(interval)?.delay, // Time between transitions in milliseconds (default 3000)
        disableOnInteraction: true, // Continue autoplay even after user interaction (default true)
      }}
      // pagination={true}
      modules={[Keyboard, Navigation, Pagination, Autoplay, EffectFade, EffectCube, EffectCards, EffectFlip, EffectCoverflow, EffectCreative]}>
      {props.book.pages?.map((page, index) => <SwiperSlide>
        <PageView book={props.book} page={props.book.pages[index]} thumbnail={true}/>
      </SwiperSlide>)}
    </Swiper>
    <IconButton style={{position: "absolute", left: 8, top: 8}}>
      {autoplayState === AutoplayState.PLAY ? <PauseCircleOutlineOutlined/> : <PlayCircleOutlineOutlined/>}
    </IconButton>
    <StyledBoxRow style={{position: "absolute", right: 8, bottom: 8, alignItems: "center", opacity: 0.8}}>
      <Typography variant={"caption"} style={{color: "white"}}>Powered by</Typography>
      <img src={"/images/dentwyze_logotype_w.svg"} style={{height: 20}}/>
    </StyledBoxRow>
  </div>;
}